import { AbstractControl, ValidationErrors } from '@angular/forms';

const MIME_TYPE: { [key: string]: string } = {
  'application/pdf': 'PDF',
  'image/jpeg': 'JPEG',
  'image/jpg': 'JPG',
  'image/png': 'PNG',
  'text/plain': 'TXT'
};

export const fileTypeValidator = (allowedTypes: string[]) => {
  return (control: AbstractControl): ValidationErrors | null => {
    const controlValue = control.value;
    if (!controlValue) {
      return null;
    }

    const inputFile = controlValue instanceof File ? controlValue : controlValue?.[0];
    if (!inputFile) {
      return null;
    }

    const isAllowedFileType = allowedTypes.includes(inputFile.type);
    if (isAllowedFileType) {
      return null;
    }

    return createInvalidFileTypeError(allowedTypes);
  };
};

const createInvalidFileTypeError = (allowedTypes: string[]): ValidationErrors => {
  const readableTypes = generateReadableAllowedFileTypes(allowedTypes);
  return {
    invalidFileType: {
      message: $localize`:formError|The file has to be one of the given types@@fileTypeNotSupported:Ongeldig bestandstype. Toegestane types: ${readableTypes}.`
    }
  };
};

const generateReadableAllowedFileTypes = (allowedTypes: string[]): string => {
  return allowedTypes.map(mimeToExtension).join(', ');
};

const mimeToExtension = (mime: string): string => {
  return MIME_TYPE[mime] || mime;
};
